import _jsonp from 'jsonp';

export default function jsonp(url,data,option){
    url += (url.includes("?") ? "&" : "?") + getParam(data); 
    return new Promise((resolve,reject)=>{
        _jsonp(url,option,(err,data)=>{
            if(!err){
                resolve(data);
            }else{
                reject(err);
            }
        })
    })
}
// 对 data 进行处理拼接到url上
function getParam(data){
    let url="";
    for(let item in data){
        let tmpVal = data[item];
        let value = (tmpVal !== undefined ? tmpVal :'');
        url += `&${item}=${encodeURIComponent(value)}`;
    }
    return url ? url.substring(1) : '';
}


// WEBPACK FOOTER //
// ./src/components/jsonp.js